/* loaded by smart-asset */
export default require("./assets/pallet-case.i.svg")